import React from "react";

import { IconButton, IconButtonSize } from "../../controls";
import { Box } from "../../layout";
import ContextPopup from "../components/ContextPopup";
import ContextMenu from "../components/ContextPopup/components/ContextMenu";
import PopupArrow from "../components/PopupArrow";
import { Position } from "../types";

export const dotsDirections = Object.freeze({
  horizontal: "dotsHorizontal" as const,
  vertical: "dotsVertical" as const
});

export type DotsDirection = keyof typeof dotsDirections;

type Props = {
  children: React.ReactNode;
  position: Position;
  dotsDirection?: DotsDirection;
  anchorSize?: IconButtonSize;
  ariaLabel?: string;
};

export default function DotsClickMenu({
  children,
  position = "bottom",
  dotsDirection = "vertical",
  anchorSize,
  ariaLabel = "Options"
}: Props) {
  const iconName = dotsDirections[dotsDirection];
  return (
    <ContextPopup position={position}>
      {{
        anchor: ({ anchorProps }) => (
          <IconButton
            iconName={iconName}
            accessibilityLabel={ariaLabel}
            tone="neutral"
            blend
            {...anchorProps}
            size={anchorSize}
          />
        ),
        popup: () => (
          <Box display="flex" alignItems="center" position="relative">
            <ContextMenu>{children}</ContextMenu>
            <PopupArrow position={position} />
          </Box>
        )
      }}
    </ContextPopup>
  );
}
